<template>
  <v-card flat class="formas-pago-entrega">
    <p class="section-label">Forma de entrega</p>
    <v-radio-group
      ref="formaDeEntrega"
      v-model="formasEntregaGroup"
      v-if="clientData && clientData.formasEnvio"
      hide-details
      class="mt-0"
    >
      <v-radio
        v-for="formaEnvio in clientData.formasEnvio"
        :key="`formaEnvio_${formaEnvio.id}`"
        :label="formaEnvio.name"
        :value="formaEnvio.id"
        @change="(minimo = formaEnvio.minimo),(showTextoImporteMinimo = formaEnvio.minimo > total),$emit('importeMinimoChange', formaEnvio.minimo > total)"
      ></v-radio>
    </v-radio-group>

    <div v-if="usarSeleccionHorario" class="horario-block">
      <div class="horario-switch-row">
        <div>
          <div class="horario-title">Programar horario para hoy</div>
          <div class="horario-hint">Si no lo activás, lo preparamos lo antes posible</div>
        </div>
        <v-switch
          :input-value="horarioDistinto"
          dense
          hide-details
          color="primary"
          class="mt-0 pt-0"
          @change="onHorarioDistintoChange"
        ></v-switch>
      </div>
      <v-select
        v-if="horarioDistinto"
        :value="horaProgramada"
        :items="horaSlots"
        :label="horaLabel"
        :rules="[v => !!v || 'Elegí una hora']"
        prepend-inner-icon="mdi-clock-outline"
        outlined
        dense
        hide-details="auto"
        class="mt-3"
        no-data-text="No hay horarios disponibles para hoy"
        @change="onHoraChange"
      ></v-select>
      <div v-if="horarioDistinto && horaSlots.length === 0" class="horario-empty">
        No quedan horarios disponibles para hoy. Desactivá la programación o pedí lo antes posible.
      </div>
    </div>

    <p class="section-label mt-4">Forma de pago</p>
    <v-radio-group
      ref="formaDePago"
      v-model="formasPagoGroup"
      v-if="clientData && clientData.formasPago"
      hide-details
      class="mt-0"
    >
      <v-radio
        v-for="formaPago in clientData.formasPago"
        :key="`formaPago_${formaPago.id}`"
        :label="formaPago.name"
        :value="formaPago.id"
        @change="mostrarTexto(formaPago.Texto)"
      ></v-radio>
    </v-radio-group>
    <h5 v-if="showTextoFormaPago">{{ textoFormaPago }}</h5>
    <h5 v-if="descuento">{{`Tenes un descuento disponible del ${descuento.PorcentajeDesct}%.`  }}</h5>
    <h5 v-if="showTextoImporteMinimo" class="error--text">{{`El mínimo de compra es $${minimo}.`  }}</h5>
  </v-card>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapMutations, mapState } from 'vuex'
import { bus } from '@/helpers/bus.js'
import descuentoHelper from '@/helpers/descuentosHelper.js'
import { buildHoyTimeSlots } from '@/helpers/horarioProgramado.js'

export default {
  name: 'FormasPagoEntrega',
  mounted () {
    this.formasPagoGroup = this.clientData && this.clientData.formasPago.length === 1 ? this.clientData.formasPago[0].id : this.clientData && this.clientData.formasPago.length > 0
      ? this.clientData.formasPago.filter((e) => e.default).length > 0 ? this.clientData.formasPago.filter((e) => e.default)[0].id : this.clientData.formasPago.filter((e) => e.id === 1)[0].id : null
    this.formasEntregaGroup = this.clientData && this.clientData.formasEnvio.length === 1
      ? this.clientData.formasEnvio[0].id : this.clientData && this.clientData.formasEnvio.length > 0
        ? this.clientData.formasEnvio.filter((e) => e.default).length > 0
          ? this.clientData.formasEnvio.filter((e) => e.default)[0].id : this.clientData.formasEnvio.filter((e) => e.name.includes('Retira en'))[0].id : null
    bus.$on('retirar-pedido', this._onRetirarPedido)
    this.descuento = descuentoHelper.getDescuento(this.formasPagoGroup)
    if (this.clientData && this.clientData.formasEnvio && this.formasEntregaGroup) {
      const formaEnvio = this.clientData.formasEnvio.filter(e => e.id === this.formasEntregaGroup)[0]
      if (formaEnvio && formaEnvio.minimo > this.total) {
        this.$emit('importeMinimoChange', true)
        this.minimo = formaEnvio.minimo
      }
    }
    this.$nextTick(() => {
      if (this.formasEntregaGroup != null) {
        this.setFormaEntrega(this.formasEntregaGroup)
      }
    })
    if (!this.usarSeleccionHorario) {
      this.setHorarioDistinto(false)
      this.setHoraProgramada(null)
    }
  },
  beforeDestroy () {
    if (this._onRetirarPedido) bus.$off('retirar-pedido', this._onRetirarPedido)
  },
  created () {
    this._onRetirarPedido = (event) => {
      if (event && this.clientData && this.clientData.formasEnvio) {
        const retira = this.clientData.formasEnvio.filter((e) => e.name.includes('Retira en'))[0]
        if (retira) this.formasEntregaGroup = retira.id
      }
    }
  },
  computed: {
    ...mapGetters({
      clientData: 'App/data',
      total: 'Carrito/getTotal'
    }),
    ...mapState('Checkout', ['horarioDistinto', 'horaProgramada', 'formaEntrega']),
    usarSeleccionHorario () {
      return !!(this.clientData && this.clientData.UsarSeleccionHorario)
    },
    horaSlots () {
      const dataOriginal = this.clientData && this.clientData.horarioRegular
        ? this.clientData.horarioRegular.dataOriginal
        : null
      return buildHoyTimeSlots(dataOriginal)
    },
    horaLabel () {
      return this.formaEntrega === 2 ? 'Hora de retiro' : 'Hora de entrega'
    }
  },
  methods: {
    ...mapMutations('Checkout', [
      'setFormaEntrega',
      'setHorarioDistinto',
      'setHoraProgramada'
    ]),
    onHorarioDistintoChange (val) {
      this.setHorarioDistinto(val)
      if (val) {
        if (!this.horaProgramada && this.horaSlots.length) {
          this.setHoraProgramada(this.horaSlots[0])
        } else if (this.horaProgramada && !this.horaSlots.includes(this.horaProgramada)) {
          this.setHoraProgramada(this.horaSlots[0] || null)
        }
      }
    },
    onHoraChange (val) {
      this.setHoraProgramada(val)
    },
    onFormaPagoChange () {
      // Payment Brick se monta desde Resumen al confirmar; solo actualizar descuento.
      this.descuento = this.clientData && this.clientData.Descuentos ? this.clientData.Descuentos.filter(d => d.FPagoId === this.formasPagoGroup)[0] : null
    },
    mostrarTexto (texto) {
      this.showTextoFormaPago = texto
      this.textoFormaPago = texto
    }
  },
  data () {
    return {
      formasEntregaGroup: null,
      formasPagoGroup: null,
      showTextoFormaPago: false,
      textoFormaPago: null,
      descuento: null,
      showTextoImporteMinimo: false,
      minimo: 0
    }
  },
  watch: {
    formasEntregaGroup (nuevaFormaEntrega, viejaFormaEntrega) {
      bus.$emit('onFormaEntregaChangedBus', nuevaFormaEntrega)
      this.setFormaEntrega(nuevaFormaEntrega)
    },
    formasPagoGroup (nuevaFormaPago, viejaFormaPago) {
      bus.$emit('onFormaPagoChangedBus', nuevaFormaPago)
      this.onFormaPagoChange()
    },
    horaSlots (slots) {
      if (!this.horarioDistinto) return
      if (this.horaProgramada && slots.includes(this.horaProgramada)) return
      this.setHoraProgramada(slots[0] || null)
    }
  }
}
</script>
<style scoped>
.formas-pago-entrega {
  text-align: left;
  padding: 4px 2px 8px;
}
.section-label {
  margin: 0 0 8px;
  font-size: 1.05rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}
.horario-block {
  margin-top: 12px;
  padding: 12px 14px;
  background: #fafafa;
  border: 1px solid #efefef;
  border-radius: 14px;
}
.horario-switch-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.horario-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}
.horario-hint {
  margin-top: 2px;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.5);
}
.horario-empty {
  margin-top: 8px;
  font-size: 0.85rem;
  color: #c62828;
}
</style>
